import {
  TextField as BaseTextField,
  type TextFieldProps,
} from "$components/inputs";
import React from "react";
import { useIntl } from "react-intl";

export const TextField = React.forwardRef(
  (
    props: Omit<TextFieldProps, "clearButtonTitle">,
    ref: React.Ref<HTMLTextAreaElement>,
  ) => {
    const { formatMessage } = useIntl();

    return (
      <BaseTextField
        {...props}
        ref={ref}
        clearButtonTitle={formatMessage({
          id: "textField.clear",
          defaultMessage: "Clear",
        })}
      />
    );
  },
);
